<div class="card text-left h-100">
  <div class="card-header bg-light">
    <h4 class="card-title mb-0">
      <i class="fas fa-pencil-alt pr-2"></i> {{this.titulo}} - Matriz de Risco e Controles do processo auditado
    </h4>
  </div>
  <div class="card-body wrapper m-0">
    <div class="row mb-1">
      <div class="col-md-12">
        Mapeamento do processo, Riscos e Controles Associados - OPA nº {{ numeroOpa }}
      </div>
    </div>
    <div class="row mb-2">
      <div class="col-md-12">
        Mapeamento e avaliação de riscos do processo auditado
      </div>
    </div>
    <div class="row mb-1">
      <div class="col-md-2">
        Unidade auditada:
      </div>
      <div class="col-md-10">
        <select [disabled]="bloqueiaCampos()" id="selectCriterio" class="form-control form-control-sm"
          (change)="changeUnidade()" [(ngModel)]="objPrincipal.idUnidadeSubTipo">
          <option [value]="obj.unidadeGestoraId + '-' + obj.subTipoAuditoriaId" *ngFor="let obj of unidadesGetoras">{{
            obj.unidadeGestora.nome + " - " + obj.subtipoAuditoria.nome }}</option>
        </select>
      </div>
    </div>
    <div class="row mb-1">
      <div class="col-md-2">
        Processo de trabalho auditado:
      </div>
      <div class="col-md-10">
        <input [disabled]="bloqueiaCampos()" type="text" id="txtProcesso" class="form-control form-control-sm"
          [(ngModel)]="objPrincipal.nomeProcesso" maxlength="100" minlength="2" />
      </div>
    </div>
    <div class="row mb-2">
      <div class="col-md-2">
        Critério de Avaliação de Riscos:
      </div>
      <div class="col-md-10">
        <select [disabled]="bloqueiaCampos()" id="selectCriterio" class="form-control form-control-sm"
          (change)="changeCriterios()" [(ngModel)]="objPrincipal.idCriterioAvaliacao">
          <option *ngFor="let obj of listCriterios" [ngValue]="obj.id">{{ obj.nome }}</option>
        </select>
      </div>
      <div style="padding: 15px; border-bottom: 1px solid #f1f1f1;" [hidden]="!importar">
        <div class="mb-3">
          <div>
            <label for="fileInput" class="form-label">Selecione um arquivo do tipo XLS ou XLSX, limite de 200MB</label>
          </div>
          <input type="file" id="fileInput" (change)="importarArquivo($event)" accept=".xlsx" #fileInput [disabled]="!canImportar()"/>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="card card-outline card-lightblue">
          <div class="card-header pb-0">
            <ul class="nav nav-tabs ml-auto p-0">
              <li class="nav-item">
                <a class="nav-link" [ngClass]="{ active: aba === 0 }" (click)="mudarAba(0)">Atividades</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" [ngClass]="{ active: aba === 1 }" (click)="mudarAba(1)">Riscos Identificados</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" [ngClass]="{ active: aba === 2 }" (click)="mudarAba(2)">Controles Associados</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" [ngClass]="{ active: aba === 3 }" (click)="mudarAba(3)">Testes</a>
              </li>
            </ul>
          </div>
          <div class="card-body">
            <div #abaDados [hidden]="aba !== 0">
              <app-mr-aba-atividades [objPrincipal]="objPrincipal" [visualizar]="visualizar"></app-mr-aba-atividades>
            </div>
            <div #abaDados [hidden]="aba !== 1">
              <app-mr-aba-riscos [objPrincipal]="objPrincipal" [visualizar]="visualizar"></app-mr-aba-riscos>
            </div>
            <div #abaDados [hidden]="aba !== 2">
              <app-mr-aba-controle [objPrincipal]="objPrincipal" [visualizar]="visualizar"></app-mr-aba-controle>
            </div>
            <div #abaDados [hidden]="aba !== 3">
              <app-mr-aba-testes [objPrincipal]="objPrincipal" [visualizar]="visualizar"></app-mr-aba-testes>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card-footer">
      <div class="d-flex w-100 justify-content-between align-items-center">
        <div class="list2">
          <div class="btn-group" [hidden]="visualizar">
            <button class="btn btn-primary btn-sm mr" (click)="salvar(false)">
              <i class="far fa-save"></i> Salvar
            </button>
            <button type="button" class="btn btn-primary btn-sm mr dropdown-toggle dropdown-icon" data-toggle="dropdown"
              aria-expanded="false"></button>
            <div class="dropdown-menu" role="menu">
              <a class="dropdown-item" (click)="salvar(false)">Salvar</a>
              <a class="dropdown-item" (click)="salvar(true)">Salvar e fechar</a>
            </div>
          </div>
          &nbsp;
          <button type="button" class="btn btn-default btn-sm" (click)="cancelar()">
            <i class="fas fa-times"></i> Cancelar
          </button>
        </div>
      </div>
    </div>
  </div>